import { render, staticRenderFns } from "./SingleDevice.vue?vue&type=template&id=c64a95a2"
import script from "./SingleDevice.vue?vue&type=script&lang=js"
export * from "./SingleDevice.vue?vue&type=script&lang=js"
import style0 from "./SingleDevice.vue?vue&type=style&index=0&id=c64a95a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports